import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineAppstore,
  AiOutlineTool,
  AiOutlineMail,
} from "react-icons/ai";

// Memoize NavBar to prevent unnecessary re-renders
const NavBar = React.memo(function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    let ticking = false;
    let rafId = null;
    
    function scrollHandler() {
      if (!ticking) {
        rafId = requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          if (scrollY >= 20) {
            updateNavbar(true);
            if (!hasScrolled) {
              setHasScrolled(true);
            }
          } else {
            updateNavbar(false);
            setHasScrolled(false);
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener("scroll", scrollHandler, { passive: true });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [hasScrolled]);

  return (
    <motion.div
      initial={{ y: hasScrolled ? '-100%' : 0 }}
      animate={{ y: hasScrolled ? 0 : 0 }}
      transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
    >
      <Navbar
        expanded={expand}
        fixed="top"
        expand="md"
        className={navColour ? "sticky" : "navbar"}
      >
        <Container>
          <Navbar.Brand href="/" className="d-flex">
            <img src={logo} className="img-fluid logo" alt="Development Agency" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => {
              updateExpanded(expand ? false : "expanded");
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="#home">
              <Nav.Item>
                <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)} className="nav-link-hover">
                  <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/services"
                  onClick={() => updateExpanded(false)}
                  className="nav-link-hover"
                >
                  <AiOutlineAppstore style={{ marginBottom: "2px" }} /> Services
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/work"
                  onClick={() => updateExpanded(false)}
                  className="nav-link-hover"
                >
                  <AiOutlineFundProjectionScreen
                    style={{ marginBottom: "2px" }}
                  />{" "}
                  Work
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/process"
                  onClick={() => updateExpanded(false)}
                  className="nav-link-hover"
                >
                  <AiOutlineTool style={{ marginBottom: "2px" }} /> Process
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/contact"
                  onClick={() => updateExpanded(false)}
                  className="nav-link-hover"
                >
                  <AiOutlineMail style={{ marginBottom: "2px" }} /> Contact
                </Nav.Link>
              </Nav.Item>

              {/* Blog hidden for now */}
              <Nav.Item style={{ display: "none" }}>
                <Nav.Link href="#" target="_blank" rel="noreferrer">
                  <ImBlog style={{ marginBottom: "2px" }} /> Blog
                </Nav.Link>
              </Nav.Item>

              {/* Fork/Star hidden for now */}
              <Nav.Item className="fork-btn" style={{ display: "none" }}>
                <Button href="#" target="_blank" className="fork-btn-inner">
                  <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                  <AiFillStar style={{ fontSize: "1.1em" }} />
                </Button>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </motion.div>
  );
});

export default NavBar;
